<template>
  <div>
          <p :style="pStyle">更新日志</p>
          <Timeline>
            <TimelineItem
              color="green"
              v-for="(vv, kk) in info"
              :key="kk"
            >
              <p class="version">版本号：{{ vv.version }}</p>
              <p class="time">{{ vv.time }}</p>
              <!-- <p class="content">{{ vv.content || "" }}</p> -->
              <div class="content" v-html="vv.content"></div>
            </TimelineItem>
          </Timeline>
        </div>
</template>
<script>
export default {
  name: "index",
  components: {},
  data() {
    return {
      info: {},
    };
  },
  created() {
    this.loadHomeData();
  },
  methods: {
    loadHomeData() {
      let q = {};
      $utils.api.load("admin/system/developLog/list2", q, "GET").then((res) => {
        if (res.rows) {
          let info = res.rows || {};
          let dropList = [];
          if (info && info.length > 0) {
            for (let index = 0; index < info.length; index++) {
              const element = info[index];
              let xx = {};
              xx.content = element["content"].replace(/\n/g, '<br>') || "";
              // res.data.replace(/\n/g, '<br>')
              xx.time = element["createTime"] || "";
              xx.version = element["version"] || "";
              dropList.push(xx);
            }
            this.info = dropList;
          }
        }
      });
    },
  },
};
</script>

